import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderLine, SalesOrderDetails, Duplicate } from '@equipmyschool/emsadminweb-models';

export interface DuplicationDialogData {
  line: OrderLine;
  order: SalesOrderDetails;
  duplicates: Duplicate[];
}

@Component({
  selector: 'app-duplication-dialog',
  templateUrl: './duplication-dialog.component.html',
  styleUrls: ['./duplication-dialog.component.scss']
})
export class DuplicationDialogComponent {
  public line: OrderLine;
  public order: SalesOrderDetails;
  public duplicates: Duplicate[];

  constructor(
    public dialogRef: MatDialogRef<DuplicationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DuplicationDialogData
  ) {
    this.line = data.line;
    this.order = data.order;
    this.duplicates = data.duplicates;
  }
}
